module.exports = __webpack_public_path__ + "img/expenses.754e58db.svg";